export default {"src":"/_next/static/media/gramax-logo-hp-light.1bf88f15.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};